import { render, staticRenderFns } from "./pencil.vue?vue&type=template&id=2408e32d&scoped=true&lang=pug"
import script from "./pencil.vue?vue&type=script&lang=js"
export * from "./pencil.vue?vue&type=script&lang=js"
import style0 from "@/CommonDP/mongeView/common/common.scss?vue&type=style&index=0&id=2408e32d&prod&lang=scss&scoped=true&external"
import style1 from "./pencil.vue?vue&type=style&index=1&id=2408e32d&prod&lang=scss&scoped=true"
import style2 from "./pencil.vue?vue&type=style&index=2&id=2408e32d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2408e32d",
  null
  
)

export default component.exports